import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, useParams } from 'react-router-dom';
import { Watch } from "react-loader-spinner";
import { ApiService } from '../../containers/Services/apiservice';
import { Helmet } from 'react-helmet';
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
let apiServices = new ApiService();
const CANRegister = () => {
    let history = useHistory();
    const [step, setStep] = useState(1);
    const [errorMessage, setErrorMessage] = useState('');
    const [Banks, setBanks] = React.useState([]);
    const [Countries, setCountries] = React.useState([]);
    const [micrName, setMicrName] = useState('')
    const [incometype, setincometype] = useState(0);
    const [otheroccupation, setotheroccupation] = useState(0);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [othersourceofwealth, setothersourceofwealth] = useState(0);
    const [addnominee, setaddnominee] = useState(1);
    const [singleholding, setsingleholding] = useState();
    const [addholder, setaddholder] = useState(0);
    const [userminor, setuserminor] = useState(0);
    const [TaxStatusData, setTaxStatusData] = useState('');
    const [cr_id, setcr_id] = useState();
    const [cr_holding_nature, setcr_holding_nature] = useState('SI');
    const [cr_investor_category, setcr_investor_category] = useState('');
    const [cr_tax_status, setcr_tax_status] = useState('');
    const [cr_income_type, setcr_income_type] = useState();
    const [cr_source_of_wealth, setcr_source_of_wealth] = useState();
    const [cr_occupation, setcr_occupation] = useState();
    const [holder_income_type, setholder_income_type] = useState();
    const [holder_source_of_wealth, setholder_source_of_wealth] = useState();
    const [holder_occupation, setholder_occupation] = useState();
    const [cr_nominee_option, setcr_nominee_option] = useState('Y');
    const [taxresfield, settaxresfield] = useState(0);
    const [profileData, setProfileData] = useState({ dob: '', fname: '', lname: '', pan: '', mobile: '', email: '', city: '' });
    const [userbankdata, setuserbankdata] = useState({ crb_bank_acc_no1: '', confirm_bank_acc_no1: '', crb_bank_acc_type1: 'SB', crb_bank1: '', crb_bank_micr1: '', crb_bank_ifsc1: '', crb_bank_proof1: '77', crb_bank_acc_no2: '', confirm_bank_acc_no2: '', crb_bank_acc_type2: '', crb_bank2: '', crb_bank_micr2: '', crb_bank_ifsc2: '', crb_bank_proof2: '', crb_bank_acc_no3: '', confirm_bank_acc_no3: '', crb_bank_acc_type3: '', crb_bank3: '', crb_bank_micr3: '', crb_bank_ifsc3: '', crb_bank_proof3: '' });
    const [nomineeData, setNomineeData] = useState({ crn_nominee_name1: '', crn_nominee_relation1: '', crn_nominee_percent1: '', crn_nominee_dob1: '', crn_nominee_name2: '', crn_nominee_relation2: '', crn_nominee_percent2: '', crn_nominee_dob2: '', crn_nominee_name3: '', crn_nominee_relation3: '', crn_nominee_percent3: '', crn_nominee_dob3: '' });
    const [step1Data, setstep1Data] = useState({ cr_country_of_tax_residency: '', cr_tax_identification_no: '', cr_tax_identification_type: '', cr_tax_resedency_other_than_india: 'N', cr_place_of_birth: '', cr_country_of_birth: '101', cr_country_of_citizenship: '101', cr_country_of_nationality: '101', cr_gross_annual_income: '', cr_networth: '', cr_networth_ondate: '', cr_source_of_wealth_other: '', cr_occupation_other: '', cr_political_exposure: 'NA', cr_kra_addr_type: '2', cr_holders: '' });
    const [newholderData, setnewholderData] = useState({ holder_relation_proof: '', holder_relation_minor: '', holder_dob: '', holder_name: '', holder_pan: '', holder_mobile: '', holder_email: '', holder_tax_resedency_other_than_india: 'N', holder_place_of_birth: '', holder_country_of_birth: '101', holder_country_of_citizenship: '101', holder_country_of_nationality: '101', holder_gross_annual_income: '', holder_networth: '', holder_networth_ondate: '', holder_source_of_wealth_other: '', holder_occupation_other: '', holder_political_exposure: 'NA', holder_kra_addr_type: '2' });
    const [Newfile, setNewFile] = useState([]);
    const [ImageProof, setImageProof] = useState('');
    const [showmorebanks, setshowmorebanks] = useState(0);
    const [showmorenominee, setshowmorenominee] = useState(0);
    const [IsMinor, setIsMinor] = useState(0);
    const [PANproof, SetPANproof] = useState('');
    const [BANKproof, SetBANKproof] = useState('');
    const [MINORproof, SetMINORproof] = useState('');
    const [PANProofId, setPANProofId] = useState();
    const [BANKProofId, setBANKProofId] = useState();
    const [MINORProofId, setMINORProofId] = useState();
    const inputPANFile = useRef(null)
    const inputBANKFile = useRef(null)
    const inputMINORFile = useRef(null)
    const [show, setShow] = useState(false);
    const [dangershow, setdangerShow] = useState(false);
    const [successshow, setsuccessshow] = useState(false);
    const [canmodalText, setcanmodalText] = useState();
    const [nomineebackbutton, setnomineebackbutton] = useState(1);
    const { gotostep } = useParams();
    {/* <><h6>Your KYC is not done, Kindly get your eKYC done here.</h6><button type="button" className="btn btn-primary newsletter-button">Continue</button></> */ }
    useEffect(() => {
        getBanks();
        getCountries();
        if (gotostep == 5) {
            setnomineebackbutton(0);
            setStep(5);
            var element = document.getElementById('step1');
            element.classList.add("done");
            var elementtick = document.getElementById('tick1');
            elementtick.style.display = '';
            var element2 = document.getElementById('step2');
            element2.classList.add("done");
            var elementtick2 = document.getElementById('tick2');
            elementtick2.style.display = '';
            var element3 = document.getElementById('step4');
            element3.classList.add("done");
            var elementtick3 = document.getElementById('tick4');
            elementtick3.style.display = '';
            var element4 = document.getElementById('step5');
            element4.classList.add("active");
        }
        const dataString = {
        }
        apiServices.getUserData(dataString).then(result => {
            if (result.data.status == 'success') {
                setProfileData({
                    fname: result.data.data.gs_fname,
                    lname: result.data.data.gs_lname,
                    dob: result.data.data.gs_dob,
                    pan: result.data.data.gs_pan_no,
                    mobile: result.data.data.gs_mobile,
                    email: result.data.data.gs_email,
                    city: result.data.data.city.cities_name,
                });
                setIsMinor(result.data.data.gs_isminor)
                setstep1Data({ ...step1Data, ['cr_place_of_birth']: result.data.data.city.cities_name })
                setnewholderData({ ...newholderData, ['holder_place_of_birth']: result.data.data.city.cities_name })
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
            }
        })
    }, []);
    function uploadSingleFile(e) {
        setNewFile([...Newfile, e.target.files[0]]);
    }
    function uploadPAN(e) {
        SetPANproof(e.target.files[0]);
        upload(e.target.files[0], '1#PC')
    }
    function uploadBANK(e) {
        SetBANKproof(e.target.files[0]);
        upload(e.target.files[0], '2#BP')
    }
    function uploadSMINOR(e) {
        SetMINORproof(e.target.files[0]);
        upload(e.target.files[0], '4#FA')
    }
    const upload = (imageraw, PROOF) => {
        setSpinnerLoading(true);
        const formData = new FormData();
        formData.append('proof_img', imageraw);
        formData.append('proof_url', URL.createObjectURL(imageraw));
        formData.append('proof_type', PROOF);
        formData.append('operation', 'AD');
        apiServices.canproofupload(formData).then(result => {
            if (result.data.data.responseCode == '0') {
                setSpinnerLoading(false);
                if (PROOF == '1#PC') {
                    setPANProofId(result.data.proofid);
                } else if (PROOF == '2#BP') {
                    setBANKProofId(result.data.proofid);
                } else if (PROOF == '4#FA') {
                    setMINORProofId(result.data.proofid);
                }
                alert(result.data.data.responseMsg);
                // var element= document.getElementById('uploadbutton'+index);
                // element.style.display = 'none';
                // var element2= document.getElementById('deletebutton'+index);
                // element2.style.display = 'none';
                // var element3= document.getElementById('serverdeletebutton'+index);
                // element3.style.display = '';
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
            }
        })
    }
    const checkbankproofvaklidation = (index) => {
        if (PANproof == '' || PANproof == null || PANproof == undefined) {
            alert('Please Upload PAN Proof First');
            return false;
        }
        if (BANKproof == '' || BANKproof == null || BANKproof == undefined) {
            alert('Please Upload Bank Proof First');
            return false;
        }
        setSpinnerLoading(true);
        const dataString = {
        }
        apiServices.canuserproofdata(dataString).then(result => {
            if (result.data.status == 'success') {
                setSpinnerLoading(false);
                history.push("/nomineeverify");
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
            }
        })
    }
    const removeimageserver = (ProofId) => {
        setSpinnerLoading(true);
        const dataString = {
            "id": ProofId
        }
        apiServices.canproofremove(dataString).then(result => {
            if (result.data.responseCode == '0') {
                setSpinnerLoading(false);
                alert(result.data.responseMsg);
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                setSpinnerLoading(false);
                alert(result.data.responseMsg);
                return false;
            }
        })
    }
    function deleteFile(e) {
        const s = Newfile.filter((item, index) => index !== e);
        setNewFile(s);
    }
    const handleInput = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        if (key == 'cr_tax_resedency_other_than_india') {
            if (value == 'Y') {
                settaxresfield(1);
            }
            else {
                settaxresfield(0);
            }
        }
        setstep1Data({ ...step1Data, [key]: value })
    }
    const onButtonClick = (inputfile) => {
        inputfile.current.click();
    };
    const handleBankData = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        if (key == "crb_bank_ifsc1") {
            if (value.length == 11) {
                apiServices.getMICRGetRequest(value).then(res => {
                    console.log(res)
                    if (res.status == 200) {
                        setMicrName(res.data.MICR)
                        // setMicrName({...micrName, ['crb_bank_micr1']:res.data.MICR})
                    }
                    else {
                        setMicrName('')
                    }
                })
                    .catch(error => {
                        setMicrName('')
                    }
                    )
            } else {
                setMicrName('')
            }
        }
        if (key == "crb_bank_micr1") {
            setMicrName(value);
        } else {
            setuserbankdata({ ...userbankdata, [key]: value })
        }
    }
    const handleNomineeData = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        setNomineeData({ ...nomineeData, [key]: value })
    }
    const handleSecondHolderata = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        setnewholderData({ ...newholderData, [key]: value })
    }
    const getBanks = (e) => {
        apiServices.getBanks().then(result => {
            if (result.data.status == 'success') {
                setBanks(result.data.data);
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
            }
        })
    }
    const getCountries = (e) => {
        apiServices.getCountries().then(result => {
            if (result.data.status == 'success') {
                setCountries(result.data.data);
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
            }
        })
    }
    const previousstep = (e) => {
        if (addholder == 0) {
            if (step == 4) {
                var element = document.getElementById('step' + step);
                element.classList.remove("active");
                var elementtick = document.getElementById('tick' + (step - 2));
                elementtick.style.display = 'none';
                var element2 = document.getElementById('step' + (step - 2));
                element2.classList.remove("done");
                // element2.classList.remove("active");
                element2.classList.add("active");
                setStep(step - 2);
            }
            else {
                var element = document.getElementById('step' + step);
                element.classList.remove("active");
                var elementtick = document.getElementById('tick' + (step - 1));
                elementtick.style.display = 'none';
                var element2 = document.getElementById('step' + (step - 1));
                element2.classList.remove("done");
                // element2.classList.remove("active");
                element2.classList.add("active");
                setStep(step - 1);
            }
        }
        else {
            var element = document.getElementById('step' + step);
            element.classList.remove("active");
            var elementtick = document.getElementById('tick' + (step - 1));
            elementtick.style.display = 'none';
            var element2 = document.getElementById('step' + (step - 1));
            element2.classList.remove("done");
            // element2.classList.remove("active");
            element2.classList.add("active");
            setStep(step - 1);
        }

    }
    const stepincrement = (e) => {
        if (addholder == 0) {
            setsuccessshow(false);
            if (step == 2) {
                // setStep(step+1);
                var element = document.getElementById('step' + step);
                element.classList.add("done");
                var elementtick = document.getElementById('tick' + step);
                elementtick.style.display = '';
                var element2 = document.getElementById('step' + (step + 2));
                element2.classList.add("active");
                setStep(step + 2);
            }
            else {
                var element = document.getElementById('step' + step);
                element.classList.add("done");
                var elementtick = document.getElementById('tick' + step);
                elementtick.style.display = '';
                var element2 = document.getElementById('step' + (step + 1));
                element2.classList.add("active");
                setStep(step + 1);
            }
        }
        else {
            var element = document.getElementById('step' + step);
            element.classList.add("done");
            var elementtick = document.getElementById('tick' + step);
            elementtick.style.display = '';
            var element2 = document.getElementById('step' + (step + 1));
            element2.classList.add("active");

            setStep(step + 1);
        }
    }
    const processstep1 = (e) => {
        if (cr_investor_category == '') {
            setErrorMessage('Investor Category Field is Required');
            return false;
        }
        else if (cr_tax_status == '') {
            setErrorMessage('Tax Status Field is Required');
            return false;
        }
        else {
            setErrorMessage('')
        }
        setSpinnerLoading(true);
        setTimeout(() => {
            const dataString = {
                "step": 1,
                "cr_holding_nature": cr_holding_nature,
                "cr_investor_category": cr_investor_category,
                "cr_tax_status": cr_tax_status,
                "cr_holders": step1Data.cr_holders,
            }
            apiServices.canregisterstep(dataString).then(result => {
                if (result.data.status == 'success') {
                    setcr_id(result.data.data);
                    setSpinnerLoading(false);
                    stepincrement();
                }
                else if (result.data.status == "error" && result.data.message == "Session expired") {
                    localStorage.removeItem('AUTH_TOKEN');
                    // alert(result.data.message)
                    setSpinnerLoading(false)
                    history.push("/login")
                }
                else {
                    alert(result.data.message)
                    setSpinnerLoading(false)
                }
            })
        }, 1000);
    }
    const processstep2 = (e) => {
        // console.log(step1Data);
        // console.log(step1Data.cr_country_of_birth);
        // return false;
        if (userminor != 1) {
            if (cr_income_type == '' || cr_income_type == undefined) {
                setErrorMessage('Please Select Income Type');
                return false;
            } else {
                if (cr_income_type == 'G') {
                    if (step1Data.cr_gross_annual_income == '' || step1Data.cr_gross_annual_income == undefined) {
                        setErrorMessage('Gross Annual Income Field is Required');
                        return false;
                    }
                    else {
                        setErrorMessage('');
                    }
                } else {
                    if (step1Data.cr_networth == '' || step1Data.cr_networth == undefined) {
                        setErrorMessage('Networth Field is Required');
                        return false;
                    }
                    else if (step1Data.cr_networth_ondate == '' || step1Data.cr_networth_ondate == undefined) {
                        setErrorMessage('Networth As On Date Field is Required');
                        return false;
                    }
                    else {
                        setErrorMessage('');
                    }
                }
            }
            if (cr_source_of_wealth == '' || cr_source_of_wealth == undefined) {
                setErrorMessage('Source Of Wealth Field is Required');
                return false;
            }
            if (cr_source_of_wealth == '08' && (step1Data.cr_source_of_wealth_other == '' || step1Data.cr_source_of_wealth_other == undefined)) {
                setErrorMessage('Source Of Wealth Other Field is Required');
                return false;
            }
            if (cr_occupation == '' || cr_occupation == undefined) {
                setErrorMessage('Occupation Field is Required');
                return false;
            }
            if (cr_occupation == '99' && (step1Data.cr_occupation_other == '' || step1Data.cr_occupation_other == undefined)) {
                setErrorMessage('Occupation Other Field is Required');
                return false;
            }
            if (step1Data.cr_political_exposure == '' || step1Data.cr_political_exposure == undefined) {
                setErrorMessage('Political Exposure Field is Required');
                return false;
            }
            if (step1Data.cr_kra_addr_type == '' || step1Data.cr_kra_addr_type == undefined) {
                setErrorMessage('KRA Address Type Field is Required');
                return false;
            }
            if (step1Data.cr_political_exposure == '' || step1Data.cr_political_exposure == undefined) {
                setErrorMessage('Political Exposure Field is Required');
                return false;
            }
        }
        // if(step1Data.cr_place_of_birth == '' || step1Data.cr_place_of_birth == undefined)
        // {
        //      setstep1Data({  
        //         cr_place_of_birth:profileData.city
        //     });
        //  }
        // if(step1Data.cr_country_of_birth == '' || step1Data.cr_country_of_birth == undefined)
        // {
        //     setstep1Data({  
        //         cr_country_of_birth:'101'
        //     });
        // }

        // if(step1Data.cr_country_of_citizenship == '' || step1Data.cr_country_of_citizenship == undefined)
        // {
        //     setstep1Data({  
        //         cr_country_of_citizenship:'101'
        //     });
        // }
        // if(step1Data.cr_country_of_nationality == '' || step1Data.cr_country_of_nationality == undefined)
        // {
        //     setstep1Data({  
        //         cr_country_of_nationality:'101'
        //     });
        // }
        if (step1Data.cr_tax_resedency_other_than_india == 'Y') {
            if (step1Data.cr_country_of_tax_residency == '' || step1Data.cr_country_of_tax_residency == undefined) {
                setErrorMessage('Country Of Tax Residency Field is Required');
                return false;
            }
            else if (step1Data.cr_tax_identification_no == '' || step1Data.cr_tax_identification_no == undefined) {
                setErrorMessage('Tax Identification Numbers Field is Required');
                return false;
            }
            else if (step1Data.cr_tax_identification_type == '' || step1Data.cr_tax_identification_type == undefined) {
                setErrorMessage('Tax Identification Types Field is Required');
                return false;
            }
            else {
                setErrorMessage('');
            }
        }
        setErrorMessage('');
        setSpinnerLoading(true);
        setTimeout(() => {
            const dataString = {
                "step": 2,
                "cr_income_type": cr_income_type,
                "cr_gross_annual_income": step1Data.cr_gross_annual_income,
                "cr_networth": step1Data.cr_networth,
                "cr_networth_ondate": step1Data.cr_networth_ondate,
                "cr_source_of_wealth": cr_source_of_wealth,
                "cr_occupation": cr_occupation,
                "cr_political_exposure": step1Data.cr_political_exposure,
                "cr_kra_addr_type": step1Data.cr_kra_addr_type,
                "cr_tax_resedency_other_than_india": step1Data.cr_tax_resedency_other_than_india,
                "cr_place_of_birth": step1Data.cr_place_of_birth,
                "cr_country_of_birth": step1Data.cr_country_of_birth,
                "cr_country_of_citizenship": step1Data.cr_country_of_citizenship,
                "cr_country_of_nationality": step1Data.cr_country_of_nationality,
                "cr_source_of_wealth_other": step1Data.cr_source_of_wealth_other,
                "cr_occupation_other": step1Data.cr_occupation_other,
                "cr_country_of_tax_residency": step1Data.cr_country_of_tax_residency,
                "cr_tax_identification_no": step1Data.cr_tax_identification_no,
                "cr_tax_identification_type": step1Data.cr_tax_identification_type,
            }
            apiServices.canregisterstep(dataString).then(result => {
                if (result.data.status == 'success') {
                    setcr_id(result.data.data);
                    setSpinnerLoading(false);
                    stepincrement();
                }
                else if (result.data.status == "error" && result.data.message == "Session expired") {
                    localStorage.removeItem('AUTH_TOKEN');
                    // alert(result.data.message)
                    setSpinnerLoading(false)
                    history.push("/login")
                }
                else {
                    alert('something went wrong');
                    window.location.reload();
                }
            })

        }, 1000);
    }
    const processsnewholder = (e) => {
        if (newholderData.holder_name == '' || newholderData.holder_name == undefined) {
            setErrorMessage('Guardian Name Field is Required');
            return false;
        }
        else if (newholderData.holder_dob == '' || newholderData.holder_dob == undefined) {
            setErrorMessage('Guardian Date Of Birth Field is Required');
            return false;
        }
        else if (newholderData.holder_pan == '' || newholderData.holder_pan == undefined) {
            setErrorMessage('Guardian PAN Field is Required');
            return false;
        }
        else if (newholderData.holder_mobile == '' || newholderData.holder_mobile == undefined) {
            setErrorMessage('Guardian Mobile Field is Required');
            return false;
        }
        else if (newholderData.holder_email == '' || newholderData.holder_email == undefined) {
            setErrorMessage('Guardian Email Field is Required');
            return false;
        }
        else {
            setErrorMessage('')
        }
        if (cr_investor_category == 'M') {
            if (newholderData.holder_relation_minor == '' || newholderData.holder_relation_minor == undefined) {
                setErrorMessage('Guardian Relation With Minor Field Is Required');
                return false;
            }
            else if (newholderData.holder_relation_proof == '' || newholderData.holder_relation_proof == undefined) {
                setErrorMessage('Guardian Relation Proof Field Is Required');
                return false;
            }
            else {
                setErrorMessage('');
            }
        }
        if (holder_income_type == '' || holder_income_type == undefined) {
            setErrorMessage('Please Select Income Type');
            return false;
        } else {
            if (holder_income_type == 'G') {
                if (newholderData.holder_gross_annual_income == '' || newholderData.holder_gross_annual_income == undefined) {
                    setErrorMessage('Gross Annual Income Field is Required');
                    return false;
                }
                else {
                    setErrorMessage('');
                }
            } else {
                if (newholderData.holder_networth == '' || newholderData.holder_networth == undefined) {
                    setErrorMessage('Networth Field is Required');
                    return false;
                }
                else if (newholderData.holder_networth_ondate == '' || newholderData.holder_networth_ondate == undefined) {
                    setErrorMessage('Networth As On Date Field is Required');
                    return false;
                }
                else {
                    setErrorMessage('');
                }
            }
        }
        if (holder_source_of_wealth == '' || holder_source_of_wealth == undefined) {
            setErrorMessage('Source Of Wealth Field is Required');
            return false;
        }
        else if (holder_source_of_wealth == '08' && (newholderData.holder_source_of_wealth_other == '' || newholderData.holder_source_of_wealth_other == undefined)) {
            setErrorMessage('Source Of Wealth Other Field is Required');
            return false;
        }
        else if (holder_occupation == '' || holder_occupation == undefined) {
            setErrorMessage('Occupation Field is Required');
            return false;
        }
        else if (holder_occupation == '99' && (newholderData.holder_occupation_other == '' || newholderData.holder_occupation_other == undefined)) {
            setErrorMessage('Occupation Other Field is Required');
            return false;
        }
        else if (newholderData.holder_political_exposure == '' || newholderData.holder_political_exposure == undefined) {
            setErrorMessage('Political Exposure Field is Required');
            return false;
        }
        else if (newholderData.holder_kra_addr_type == '' || newholderData.holder_kra_addr_type == undefined) {
            setErrorMessage('KRA Address Type Field is Required');
            return false;
        }
        else if (newholderData.holder_political_exposure == '' || newholderData.holder_political_exposure == undefined) {
            setErrorMessage('Political Exposure Field is Required');
            return false;
        }
        else if (newholderData.holder_place_of_birth == '' || newholderData.holder_place_of_birth == undefined) {
            setErrorMessage('Place Of Birth Field is Required');
            return false;
        }
        else if (newholderData.holder_country_of_birth == '' || newholderData.holder_country_of_birth == undefined) {
            setErrorMessage('Country Of Birth Field is Required');
            return false;
        }
        else if (newholderData.holder_country_of_citizenship == '' || newholderData.holder_country_of_citizenship == undefined) {
            setErrorMessage('Country Of Citizenship Field is Required');
            return false;
        }
        else if (newholderData.holder_country_of_nationality == '' || newholderData.holder_country_of_nationality == undefined) {
            setErrorMessage('Country Of Nationality Field is Required');
            return false;
        }
        else if (newholderData.holder_tax_resedency_other_than_india == 'Y') {
            if (newholderData.holder_country_of_tax_residency == '' || newholderData.holder_country_of_tax_residency == undefined) {
                setErrorMessage('Country Of Tax Residency Field is Required');
                return false;
            }
            else if (newholderData.holder_tax_identification_no == '' || newholderData.holder_tax_identification_no == undefined) {
                setErrorMessage('Tax Identification Numbers Field is Required');
                return false;
            }
            else if (newholderData.holder_tax_identification_type == '' || newholderData.holder_tax_identification_type == undefined) {
                setErrorMessage('Tax Identification Types Field is Required');
                return false;
            }
            else {
                setErrorMessage('');
            }
        }
        else {
            setErrorMessage('');
        }
        setSpinnerLoading(true);
        setTimeout(() => {
            const dataString = {
                "step": 'holder',
                "holder_income_type": holder_income_type,
                "holder_dob": newholderData.holder_dob,
                "holder_name": newholderData.holder_name,
                "holder_pan": newholderData.holder_pan,
                "holder_source_of_wealth": holder_source_of_wealth,
                "holder_occupation": holder_occupation,
                "holder_mobile": newholderData.holder_mobile,
                "holder_email": newholderData.holder_email,
                "holder_tax_resedency_other_than_india": newholderData.holder_tax_resedency_other_than_india,
                "holder_place_of_birth": newholderData.holder_place_of_birth,
                "holder_country_of_birth": newholderData.holder_country_of_birth,
                "holder_country_of_citizenship": newholderData.holder_country_of_citizenship,
                "holder_country_of_nationality": newholderData.holder_country_of_nationality,
                "holder_gross_annual_income": newholderData.holder_gross_annual_income,
                "holder_networth": newholderData.holder_networth,
                "holder_networth_ondate": newholderData.holder_networth_ondate,
                "holder_source_of_wealth_other": newholderData.holder_source_of_wealth_other,
                "holder_occupation_other": newholderData.holder_occupation_other,
                "holder_political_exposure": newholderData.holder_political_exposure,
                "holder_kra_addr_type": newholderData.holder_kra_addr_type,
                "holder_relation_minor": newholderData.holder_relation_minor,
                "holder_relation_proof": newholderData.holder_relation_proof,
            }
            apiServices.canregisterstep(dataString).then(result => {
                if (result.data.status == 'success') {
                    setcr_id(result.data.data);
                    setSpinnerLoading(false);
                    stepincrement();
                }
                else if (result.data.status == "error" && result.data.message == "Session expired") {
                    localStorage.removeItem('AUTH_TOKEN');
                    // alert(result.data.message)
                    setSpinnerLoading(false)
                    history.push("/login")
                }
                else {
                    alert('something went wrong');
                    window.location.reload();
                }
            })
        }, 1000);
    }
    const processstep3 = (e) => {
        var micr = '';
        if (micrName != null) {
            micr = micrName;
        }
        else {
            micr = userbankdata.crb_bank_micr1;
        }

        if (userbankdata.crb_bank_acc_no1 == '' || userbankdata.crb_bank_acc_no1 == undefined) {
            setErrorMessage('Bank Account Number Field Is Required');
            return false;
        }
        else if (userbankdata.confirm_bank_acc_no1 == '' || userbankdata.confirm_bank_acc_no1 == undefined) {
            setErrorMessage('Confirm Bank Account Number Field Is Required');
            return false;
        }
        else if (userbankdata.confirm_bank_acc_no1 != userbankdata.crb_bank_acc_no1) {
            setErrorMessage('Bank Account Number And Confirm Bank Account Number Field Should Be Same');
            return false;
        }
        else if (userbankdata.crb_bank_acc_type1 == '' || userbankdata.crb_bank_acc_type1 == undefined) {
            setErrorMessage('Bank Account Type Field Is Required');
            return false;
        }
        else if (userbankdata.crb_bank1 == '' || userbankdata.crb_bank1 == undefined) {
            setErrorMessage('Please Select Bank Account');
            return false;
        }
        else if ((micr == '' || micr == undefined)) {
            setErrorMessage('Bank MICR Field Is Required');
            return false;
        }
        else if (micr.length > 9) {
            setErrorMessage('Bank MICR Field Should Not Exceeds 9 Characters');
            return false;
        }
        else if (userbankdata.crb_bank_ifsc1 == '' || userbankdata.crb_bank_ifsc1 == undefined) {
            setErrorMessage('Bank IFSC Field Is Required');
            return false;
        }
        else if (userbankdata.crb_bank_ifsc1.length < 11) {
            setErrorMessage('IFSC Code is less than 11 characters');
            return false;
        }
        else if (userbankdata.crb_bank_proof1 == '' || userbankdata.crb_bank_proof1 == undefined) {
            setErrorMessage('Bank Proof Field Is Required');
            return false;
        }
        else {
            setErrorMessage('');
        }
        setSpinnerLoading(true);
        setTimeout(() => {
            const dataString = {
                "step": 3,
                "crb_bank_acc_no1": userbankdata.crb_bank_acc_no1,
                "crb_bank_acc_type1": userbankdata.crb_bank_acc_type1,
                "crb_bank1": userbankdata.crb_bank1,
                "crb_bank_micr1": micr,
                "crb_bank_ifsc1": userbankdata.crb_bank_ifsc1,
                "crb_bank_proof1": userbankdata.crb_bank_proof1,
                "crb_bank_acc_no2": userbankdata.crb_bank_acc_no2,
                "crb_bank_acc_type2": userbankdata.crb_bank_acc_type2,
                "crb_bank2": userbankdata.crb_bank2,
                "crb_bank_micr2": userbankdata.crb_bank_micr2,
                "crb_bank_ifsc2": userbankdata.crb_bank_ifsc2,
                "crb_bank_proof2": userbankdata.crb_bank_proof3,
                "crb_bank_acc_no3": userbankdata.crb_bank_acc_no3,
                "crb_bank_acc_type3": userbankdata.crb_bank_acc_type3,
                "crb_bank3": userbankdata.crb_bank3,
                "crb_bank_micr3": userbankdata.crb_bank_micr3,
                "crb_bank_ifsc3": userbankdata.crb_bank_ifsc3,
                "crb_bank_proof3": userbankdata.crb_bank_proof3,
            }
            setSpinnerLoading(false);
            console.log(dataString)
            apiServices.canregisterstep(dataString).then(result => {
                if (result.data.status == 'success') {
                    // setcr_id(result.data.data);
                    setSpinnerLoading(false);
                    stepincrement();
                }
                else if (result.data.status == "error" && result.data.message == "Session expired") {
                    localStorage.removeItem('AUTH_TOKEN');
                    // alert(result.data.message)
                    setSpinnerLoading(false)
                    history.push("/login")
                }
                else {
                    alert(result.data.message)
                    setSpinnerLoading(false)
                }
            })

        }, 1000);
    }
    const processstep4 = (e) => {
        setSpinnerLoading(true);
        setTimeout(() => {
            const dataString = {
                "step": 4,
                "cr_nominee_option": cr_nominee_option,
                "crn_nominee_name1": nomineeData.crn_nominee_name1,
                "crn_nominee_relation1": nomineeData.crn_nominee_relation1,
                "crn_nominee_percent1": nomineeData.crn_nominee_percent1,
                "crn_nominee_dob1": nomineeData.crn_nominee_dob1,
                "crn_nominee_name2": nomineeData.crn_nominee_name2,
                "crn_nominee_relation2": nomineeData.crn_nominee_relation2,
                "crn_nominee_percent2": nomineeData.crn_nominee_percent2,
                "crn_nominee_dob2": nomineeData.crn_nominee_dob2,
                "crn_nominee_name3": nomineeData.crn_nominee_name3,
                "crn_nominee_relation3": nomineeData.crn_nominee_relation3,
                "crn_nominee_percent3": nomineeData.crn_nominee_percent3,
                "crn_nominee_dob3": nomineeData.crn_nominee_dob3,
            }
            apiServices.canregisterstep(dataString).then(result => {
                console.log(result.data.status);
                console.log(result);
                if (result.data.status && result.data.status == 'error') {
                    console.log('asdeasdwqe');
                    setSpinnerLoading(false);
                    setdangerShow(true);
                    setcanmodalText(
                        <h6>{result.data.message}</h6>
                    )
                }
                else if (result.data.RESP_HEADER.RES_CODE == 0) {
                    // setcr_id(result.data.data);
                    // result.data.RESP_HEADER.RES_MSG
                    // alert('Can Data Inserted Successfully\r\n Your CAN Id Is :'+result.data.RESP_BODY.CAN);
                    setSpinnerLoading(false);
                    setsuccessshow(true);
                    setcanmodalText(<><h6>Can Data Inserted Successfully</h6><h6>Your CAN Id Is : {result.data.RESP_BODY.CAN}</h6></>)
                    // stepincrement();
                }
                else if (result.data.RESP_HEADER.RES_CODE == 1 && result.data.RESP_HEADER.RES_MSG.includes('KYC Not Registered with KRA')) {
                    setSpinnerLoading(false);
                    setShow(true);
                    setcanmodalText(
                        <h6>Your KYC is not done, Kindly get your eKYC done here.</h6>
                    )
                }
                
                else {
                    setSpinnerLoading(false);

                    setdangerShow(true)
                    setcanmodalText(
                        <h6>{result.data.RESP_HEADER.RES_MSG}</h6>
                    )
                    // alert(result.data.RESP_HEADER.RES_MSG);
                    // window.location.reload();
                }
            })
        }, 1000);
    }
    const completekyc = () => {
        window.open("https://go.goalstox.com/kyc", "_blank");
        setShow(false);
    }
    const handleClose = () => setShow(false);
    const gettaxatatus = (e) => {
        let HTMLdata = '';
        let val = e.target.value;
        setcr_investor_category(e.target.value)
        if (val == 'I') {
            setuserminor(0);
            if (cr_holding_nature != 'SI') {
                setaddholder(1);
            } else {
                setaddholder(0);
            }
            HTMLdata = '<option value="">Select</option><option value="RI">RESIDENT-INDIVIDUAL</option><option value="NRI">NRI-NRE</option><option value="NNI">NRI-NRO</option><option value="NPI">PIO</option><option value="NPE">PIO (NRE)</option><option value="NPO">PIO (NRO)</option>';
        }
        else if (val == 'M') {
            setaddholder(1);
            setuserminor(1);
            HTMLdata = '<option value="">Select</option><option value="RM">RESIDENT-INDIVIDUAL (Minor)</option><option value="NRM">NRI-NRE (Minor)</option><option value="NNM">NRI-NRO (Minor)</option><option value="NPM">PIO (Minor)</option><option value="PME">PIO (Minor) NRE</option><option value="PMO">PIO (Minor) NRO</option>';
        }
        else {
            HTMLdata = '<select><option value="">Select</option></select>';
        }
        setTaxStatusData(HTMLdata);
    }
    return (
        <div>
            <Header />
            <Helmet>
                <title>eCAN Registration - Goalstox</title>
                {/* <meta name="keywords" content={pageKeywords}/>  */}
                {/* <meta name="description" content={pageDescription} /> */}
            </Helmet>
            <div className='subheader-second'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='subheader-second-flex'>
                                <h1>Let's Create Your Account (eCAN)</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className='bg-gray-light'>
                <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                    <div className='overlay-box'>
                        <Watch
                            color="#ffffff"
                            visible={spinnerLoading}
                        />
                    </div>
                </div>
                {/* <div className="container">
                    <div className="row justify-content-md-center">
                        <div className='col-lg-8 tx-center'>
                            <h3>Your eCAN is not register with us</h3>
                            <p>Thanks for setting up your profile. we have saved your requirements and will get in touch with you shortly for investments. Till then You can setup your risk profile.</p>
                            <div class="theme-button"><a class="btn" href="/dashboard">Continue</a></div>
                            </div>
                            </div>
                            </div> */}
                <div className="container-fluid">
                    {step == 6
                        ? <div className="row">
                            <div className="alert alert-danger d-flex align-items-center" role="alert">
                                You would have received an email from MFUtility to confirm your nominee. Please check your email now, and follow the instructions to approve the nominee.
                            </div>
                        </div> : ""}
                    {step == 1
                        ? <div className="row">
                            <div className="col-lg-12">
                                <div className="alert alert-info d-flex align-items-center" role="alert">
                                    <div>
                                        <h6>Please keep following documents ready to open your account.</h6>
                                        <p className='tx-13 mg-b-5'>1. Copy Of Self Attested PAN Card in GIF, JPG, JPEG, PNG, BMP formats <a href="/img/AttestedPANSample.png" target="new">(See Sample)</a></p>
                                        <p className='tx-13'>2. Copy Of Cancelled Cheque With Your Name in GIF, JPG, JPEG, PNG, BMP formats <a href="/img/cancelledchequesample.png" target="new">(See Sample)</a></p>
                                        <h6>If Cancelled cheque is not available you can upload either of the following.</h6>
                                        <p className='tx-13  mg-b-5'>1. 3 months bank statement with front page <a href="/img/bankstatementsamples.png" target="new">(See Sample)</a></p>
                                        <p className='tx-13'>2. Your Bank Passbook with front page</p>
                                    </div>
                                </div>
                            </div>
                        </div> : ""}
                    <div className="row justify-content-md-center">
                        <div className="col-lg-3">
                            <div className="ecan-step">
                                <ul>
                                    <li id="step1" className="active">
                                        <a href="#">
                                            <span className="ecan-icon">
                                                <i className="fa fa-briefcase" aria-hidden="true"></i>
                                            </span>
                                            Your Holding Pattern
                                            <span id="tick1" style={{ display: "none" }} className="ecan-scheck">
                                                <i className="fa fa-check" aria-hidden="true"></i>
                                            </span>
                                        </a>
                                    </li>
                                    <li id="step2">
                                        <a href="#">
                                            <span className="ecan-icon">
                                                <i className="fa fa-user" aria-hidden="true"></i>
                                            </span>
                                            Sole / Primary Holder
                                            <span id="tick2" style={{ display: "none" }} className="ecan-scheck">
                                                <i className="fa fa-check" aria-hidden="true"></i>
                                            </span>
                                        </a>
                                    </li>
                                    {addholder == 1 ?
                                        <li id="step3">
                                            <a href="#">
                                                <span className="ecan-icon">
                                                    <i className="fa fa-user" aria-hidden="true"></i>
                                                </span>
                                                {userminor == 1 ? 'Guardian Holder' : 'Second Holder'}
                                                <span id="tick3" style={{ display: "none" }} className="ecan-scheck">
                                                    <i className="fa fa-check" aria-hidden="true"></i>
                                                </span>
                                            </a>
                                        </li> : ''
                                    }
                                    <li id="step4">
                                        <a href="#">
                                            <span className="ecan-icon">
                                                <i className="fa fa-credit-card-alt" aria-hidden="true"></i>
                                            </span>
                                            Bank Accounts
                                            <span id="tick4" style={{ display: "none" }} className="ecan-scheck">
                                                <i className="fa fa-check" aria-hidden="true"></i>
                                            </span>
                                        </a>
                                    </li>
                                    <li id="step5">
                                        <a href="#">
                                            <span className="ecan-icon">
                                                <i className="fa fa-share" aria-hidden="true"></i>
                                            </span>
                                            Nominees
                                            <span id="tick5" style={{ display: "none" }} className="ecan-scheck">
                                                <i className="fa fa-check" aria-hidden="true"></i>
                                            </span>
                                        </a>
                                    </li>
                                    <li id="step6">
                                        <a href="#">
                                            <span className="ecan-icon">
                                                <i className="fa fa-picture-o" aria-hidden="true"></i>
                                            </span>
                                            Proof Upload
                                            <span id="tick6" style={{ display: "none" }} className="ecan-scheck">
                                                <i className="fa fa-check" aria-hidden="true"></i>
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {step == 1 ? (
                            <div className="col-lg-9">
                                <div className="ecan-form">
                                    <h6>Your Holding Pattern</h6>
                                    <hr></hr>
                                    <div className="row">
                                        {/* <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Holding Nature<span style={{color:'#ff0000'}}>*</span></label>
                        <select name="cr_holding_nature" value={cr_holding_nature} onChange={(e) => {
                            setcr_holding_nature(e.target.value);
                            if (e.target.value == "SI") {
                                setsingleholding(1);
                                setaddholder(0);
                                setstep1Data({cr_holders:1})
                            }else if(e.target.value == "JO" || e.target.value == "AS"){
                                setsingleholding(0);
                                setaddholder(1);
                                setuserminor(0);
                                setstep1Data({cr_holders:2})
                            }else {
                                setaddholder(0);
                                setsingleholding();
                            }
                        }}> */}
                                        {/* <option value="">Select</option> */}
                                        {/* <option value="SI">Single</option> */}
                                        {/* <option value="JO">Joint</option> */}
                                        {/* <option value="AS">Anyone or Survivor</option> */}
                                        {/* </select>
                    </div>
                    </div> */}
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Investor Category<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select onChange={(e) => { gettaxatatus(e) }}>
                                                    <option value="">Select</option>
                                                    <option value="I">Individual</option>
                                                    <option value="M">Minor</option>
                                                    {/* <option value="S">Sole-proprietor</option> */}
                                                </select>
                                                {(() => {
                                                    // if(cr_investor_category!='' || cr_investor_category!=undefined)
                                                    // {
                                                    // return(
                                                    //     <select onChange={(e) => {gettaxatatus(e)}}>
                                                    //     <option value="">Select</option>
                                                    //     <option value="I">Individual</option> 
                                                    //     <option value="M">Minor</option>
                                                    //     <option value="S">Sole-proprietor</option>
                                                    //     </select>
                                                    //     )
                                                    // }

                                                    // if(singleholding ==1)
                                                    // {
                                                    //     return(
                                                    //     <select onChange={(e) => {gettaxatatus(e)}}>
                                                    //     <option value="">Select</option>
                                                    //     <option value="I">Individual</option> 
                                                    //     <option value="M">Minor</option>
                                                    //     <option value="S">Sole-proprietor</option>
                                                    //     </select>
                                                    //     )
                                                    // }
                                                    // else if(singleholding ==0)
                                                    // {
                                                    //     return (
                                                    //     <select onChange={(e) => {gettaxatatus(e)}}>
                                                    //     <option value="">Select</option>
                                                    //     <option value="I">Individual</option> 
                                                    //     </select>
                                                    //     )
                                                    // }
                                                    // else{


                                                    //     return(
                                                    //     <select>
                                                    //     <option value="">Select</option>
                                                    //     </select>
                                                    //     )

                                                    // }

                                                })()}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Tax Status<span style={{ color: '#ff0000' }}>*</span></label>
                                                {TaxStatusData != '' ?
                                                    <select value={cr_tax_status} onChange={(e) => { setcr_tax_status(e.target.value) }} dangerouslySetInnerHTML={{ __html: TaxStatusData }}>
                                                    </select> :
                                                    <select><option value="">Select</option></select>
                                                }
                                                {/* {(() => {
                            if(cr_tax_status != '' && cr_tax_status != undefined && cr_investor_category != '' && cr_investor_category != undefined)
                            {
                                if(cr_investor_category == 'I')
                                {

                                    console.log('aaaaa');
                                    // if(cr_holding_nature != 'SI')
                                    // {
                                    //     setaddholder(1);  
                                    // }else{
                                    // setaddholder(0); 
                                    // }
                                    // setstep1Data({cr_holders:1})
                                    return(
                                        <select>
                                        <option value="">Select</option>
                                        <option selected={cr_tax_status == 'RI'?'true':'false'} value="RI">01-RES.IND</option>
                                        <option selected={cr_tax_status == 'NRI'?'true':'false'} value="NRI">02-NRI-NRE</option>
                                        <option selected={cr_tax_status == 'NNI'?'true':'false'} value="NNI">03-NRI-NRO</option>
                                        <option selected={cr_tax_status == 'NPI'?'true':'false'} value="NPI">05-PIO</option>
                                        <option selected={cr_tax_status == 'NPE'?'true':'false'} value="NPE">05-PIO (NRE)</option>
                                        <option selected={cr_tax_status == 'NPO'?'true':'false'} value="NPO">05-PIO (NRO)</option>
                                        </select>
                                    )
                                }
                                else if(cr_investor_category == 'M' )
                                {
                                    // setaddholder(1);
                                    // setuserminor(1);
                                    // setstep1Data({cr_holders:2})
                                    return(
                                    <select>
                                    <option value="">Select</option>
                                    <option selected={cr_tax_status == 'RM'?'true':'false'} value="RM">01-RES.IND (Minor)</option>
                                    <option selected={cr_tax_status == 'NRM'?'true':'false'} value="NRM">02-NRI-NRE (Minor)</option>
                                    <option selected={cr_tax_status == 'NNM'?'true':'false'} value="NNM">03-NRI-NRO (Minor)</option>
                                    <option selected={cr_tax_status == 'NPM'?'true':'false'} value="NPM">05-PIO (Minor)</option>
                                    <option selected={cr_tax_status == 'PME'?'true':'false'} value="PME">05-PIO (Minor) NRE</option>
                                    <option selected={cr_tax_status == 'PMO'?'true':'false'} value="PMO">05-PIO (Minor) NRO</option>
                                    </select>
                                    )
                                }
                                else if(cr_investor_category == 'S')
                                {
                                    // setaddholder(0);
                                    // setstep1Data({cr_holders:1})
                                    return (<select><option selected={cr_tax_status == 'RS'?'true':'false'} value="RS">01-RES.IND (Sole-Proprietor)</option></select>) 
                                } 
                            }
                            else{
                                // if(TaxStatusData !='')
                                // {
                                return (<select value={cr_tax_status} onChange={(e) => {setcr_tax_status(e.target.value)}} dangerouslySetInnerHTML={{__html: TaxStatusData}}>
                                </select>)
                                // }
                            }
                            })()} */}
                                            </div>
                                        </div>
                                        {/* <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Holders<span style={{color:'#ff0000'}}>*</span></label>
                        <input disabled value="1" type="text"></input>
                    </div>
                    </div> */}
                                        {
                                            errorMessage != '' ?
                                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                                        }
                                        <div className="theme-button mg-t-10">
                                            <a className="btn" onClick={processstep1}>
                                                Save & Continue
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {step == 2 ? (
                            <div className="col-lg-9">
                                <div className="ecan-form">
                                    {/* <h6>Basic Details</h6>
                <hr></hr>
                <div className="row mb-20">
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Name<span style={{color:'#ff0000'}}>*</span></label>
                        <input disabled value={profileData.fname + profileData.lname} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Date Of Birth<span style={{color:'#ff0000'}}>*</span></label>
                        <input disabled value={profileData.dob} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>PAN<span style={{color:'#ff0000'}}>*</span></label>
                        <input disabled value={profileData.pan} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Mobile<span style={{color:'#ff0000'}}>*</span></label>
                        <input disabled value={profileData.mobile} type="text"></input>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="ecan-form-group">
                        <label>Email<span style={{color:'#ff0000'}}>*</span></label>
                        <input disabled value={profileData.email} type="text"></input>
                    </div>
                    </div>
                </div> */}
                                   {userminor != 1 ?
                                        <>
                                            <h6>Additional KYC Details</h6>
                                            <hr></hr>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="ecan-form-group">
                                                        <select value={cr_income_type} onChange={(e) => {
                                                            setcr_income_type(e.target.value)
                                                            if (e.target.value == "G") {
                                                                setincometype(1);
                                                            } else if (e.target.value == "N" || e.target.value == "AS") {
                                                                setincometype(2);
                                                            } else {
                                                                setincometype(0);
                                                            }
                                                        }}>
                                                            <option value="">Select Income Type</option>
                                                            <option value="G">Gross Annual Income</option>
                                                            <option value="N">Networth</option>
                                                        </select>
                                                    </div>
                                                </div></div>
                                            {incometype == 1 ? (
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Gross Annual Income<span style={{ color: '#ff0000' }}>*</span></label>
                                                            <select name="cr_gross_annual_income" value={step1Data.cr_gross_annual_income} onChange={handleInput}>
                                                                <option value="">Select</option>
                                                                <option value="01">BELOW 1 LAC</option>
                                                                <option value="02">1-5 LAC</option>
                                                                <option value="03">5-10 LAC</option>
                                                                <option value="04">10-25 LAC</option>
                                                                <option value="05">25LAC-1CR</option>
                                                                <option value="06">Greater than 1 CR</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {incometype == 2 ? (
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Networth (in Rs.)<span style={{ color: '#ff0000' }}>*</span></label>
                                                            <input name="cr_networth" value={step1Data.cr_networth} onChange={handleInput} type="text"></input>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>As on date<span style={{ color: '#ff0000' }}>*</span></label>
                                                            <input name="cr_networth_ondate" value={step1Data.cr_networth_ondate} onChange={handleInput} type="date"></input>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Source of Wealth<span style={{ color: '#ff0000' }}>*</span></label>
                                                        <select value={cr_source_of_wealth}
                                                            onChange={(e) => {
                                                                setcr_source_of_wealth(e.target.value)
                                                                if (e.target.value == "08") {
                                                                    setothersourceofwealth(1);
                                                                } else {
                                                                    setothersourceofwealth(0);
                                                                }
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="01">Salary</option>
                                                            <option value="02">Bussiness Income</option>
                                                            <option value="03">Gift</option>
                                                            <option value="04">Ancestral Property</option>
                                                            <option value="05">Rental Income</option>
                                                            <option value="06">Prize Money</option>
                                                            <option value="07">Royalty</option>
                                                            <option value="08">Others</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {othersourceofwealth == 1 ? (
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Other</label>
                                                            <input name="cr_source_of_wealth_other" value={step1Data.cr_source_of_wealth_other} onChange={handleInput} type="text"></input>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Occupation<span style={{ color: '#ff0000' }}>*</span></label>
                                                        <select value={cr_occupation}
                                                            onChange={(e) => {
                                                                setcr_occupation(e.target.value);
                                                                if (e.target.value == "99") {
                                                                    setotheroccupation(1);
                                                                } else {
                                                                    setotheroccupation(0);
                                                                }
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="01">Private Sector Service</option>
                                                            <option value="02">Public Sector</option>
                                                            <option value="03">Business</option>
                                                            <option value="04">Professional</option>
                                                            <option value="05">Agriculturist</option>
                                                            <option value="06">Retired</option>
                                                            <option value="07">Housewife</option>
                                                            <option value="08">Student</option>
                                                            <option value="09">Forex Dealer</option>
                                                            <option value="10">Government Service</option>
                                                            <option value="99">Others</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {otheroccupation == 1 ? (
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Other</label>
                                                            <input name="cr_occupation_other" value={step1Data.cr_occupation_other} onChange={handleInput} type="text"></input>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Political Exposure<span style={{ color: '#ff0000' }}>*</span></label>
                                                        <select name="cr_political_exposure" value={step1Data.cr_political_exposure} onChange={handleInput}>
                                                            <option value="">Select</option>
                                                            <option value="NA" >Not Applicable</option>
                                                            <option value="PEP">Politically Exposed Person</option>
                                                            <option value="RPEP">
                                                                Related to Politically Exposed Person
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Your Address Type<span style={{ color: '#ff0000' }}>*</span></label>
                                                        <select name="cr_kra_addr_type" value={step1Data.cr_kra_addr_type} onChange={handleInput}>
                                                            <option value="">Select</option>
                                                            <option value="1">Residential or Business</option>
                                                            <option value="2">Residential</option>
                                                            <option value="3">Business</option>
                                                            <option value="4">Registered Office</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </> : ''
                                    }
                                    <hr></hr>
                                    <h6>FATCA Details</h6>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Tax Residency in a country other than India?<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="cr_tax_resedency_other_than_india" value={step1Data.cr_tax_resedency_other_than_india} onChange={handleInput}>
                                                    <option value="N">
                                                        No - Not a Tax Resident in a Country other than India
                                                    </option>
                                                    <option value="Y">
                                                        Yes - Tax Resident in a Country other than India
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Place of Birth<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="cr_place_of_birth" value={step1Data.cr_place_of_birth} onChange={handleInput} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Country of Birth <span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="cr_country_of_birth" value={step1Data.cr_country_of_birth} onChange={handleInput}>
                                                    <option value="">Select Country Of Birth</option>
                                                    {Countries.map((option, index) => (
                                                        <option key={index} value={option.country_can_id}>
                                                            {option.country_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Country of Citizenship<span style={{ color: '#ff0000' }}>*</span></label>

                                                <select name="cr_country_of_citizenship" value={step1Data.cr_country_of_citizenship} onChange={handleInput}>
                                                    <option value="">Select Country Of Citizenship</option>
                                                    {Countries.map((option, index) => (
                                                        <option key={index} value={option.country_can_id}>
                                                            {option.country_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Country of Nationality<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="cr_country_of_nationality" value={step1Data.cr_country_of_nationality} onChange={handleInput}>
                                                    <option value="">Select Country Of Nationality</option>
                                                    {Countries.map((option, index) => (
                                                        <option key={index} value={option.country_can_id}>
                                                            {option.country_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {taxresfield == 1 ?
                                            <>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Countries of Tax Residency<span style={{ color: '#ff0000' }}>*</span></label>
                                                        <select name="cr_country_of_tax_residency" value={step1Data.cr_country_of_tax_residency} onChange={handleInput}>
                                                            <option value="">Select Country Of Tax Residency</option>
                                                            {Countries.map((option, index) => (
                                                                <option key={index} value={option.country_can_id}>
                                                                    {option.country_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Tax Identification Numbers<span style={{ color: '#ff0000' }}>*</span></label>
                                                        <input name="cr_tax_identification_no" value={step1Data.cr_tax_identification_no} onChange={handleInput} type="text"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Tax Identification Types<span style={{ color: '#ff0000' }}>*</span></label>
                                                        <select name="cr_tax_identification_type" value={step1Data.cr_tax_identification_type} onChange={handleInput}>
                                                            <option value="">Select</option>
                                                            <option value="E">Driving License</option>
                                                            <option value="B">Election ID Card</option>
                                                            <option value="D">ID Card</option>
                                                            <option value="H">NREGA Job Card</option>
                                                            <option value="X">Not categorized</option>
                                                            <option value="O">Others</option>
                                                            <option value="C">PAN Card</option>
                                                            <option value="A">Passport</option>
                                                            <option value="T">TIN</option>
                                                            <option value="G">UIDIA / Aadhar letter</option>
                                                            <option value="OTH">Others</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </> : ''
                                        }
                                    </div>
                                    {
                                        errorMessage != '' ?
                                            <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                                    }
                                    <div className="theme-button mg-t-10">
                                        <a className="btn" onClick={previousstep}>
                                            Back
                                        </a>
                                        <a className="btn mg-l-10" onClick={processstep2}>
                                            Save & Continue
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {step == 3 ? (
                            <div className="col-lg-9">
                                <div className="ecan-form">
                                    <h6>Basic Details Of Guardian</h6>
                                    <hr></hr>
                                    <div className="row mb-20">
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Name<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="holder_name" value={newholderData.holder_name} onChange={handleSecondHolderata} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Date Of Birth<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="holder_dob" onChange={handleSecondHolderata} value={newholderData.holder_dob} type="date" ></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>PAN<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="holder_pan" onChange={handleSecondHolderata} value={newholderData.holder_pan} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Mobile<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="holder_mobile" onChange={handleSecondHolderata} value={newholderData.holder_mobile} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Email<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="holder_email" onChange={handleSecondHolderata} value={newholderData.holder_email} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Relationship with Minor<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="holder_relation_minor" onChange={handleSecondHolderata} value={newholderData.holder_relation_minor}>
                                                    <option value="">Select</option>
                                                    <option value="01">Mother</option>
                                                    <option value="02">Father</option>
                                                    <option value="03">Court Appointed Legal Guardian</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Proof of Relationship<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="holder_relation_proof" onChange={handleSecondHolderata} value={newholderData.holder_relation_proof}>
                                                    <option value="">Select</option>
                                                    <option value="01">Birth Certificate</option>
                                                    <option value="02">Ration Card</option>
                                                    <option value="03">Passport</option>
                                                    <option value="04">PAN Card</option>
                                                    <option value="05">Court Order</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <h6>Additional KYC Details Of Guardian</h6>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <select value={holder_income_type} onChange={(e) => {
                                                    setholder_income_type(e.target.value)
                                                    if (e.target.value == "G") {
                                                        setincometype(1);
                                                    } else if (e.target.value == "N" || e.target.value == "AS") {
                                                        setincometype(2);
                                                    } else {
                                                        setincometype(0);
                                                    }
                                                }}>
                                                    <option value="">Select</option>
                                                    <option value="G">Gross Annual Income</option>
                                                    <option value="N">Networth</option>
                                                </select>
                                            </div>
                                        </div></div>
                                    {incometype == 1 ? (
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="ecan-form-group">
                                                    <label>Gross Annual Income<span style={{ color: '#ff0000' }}>*</span></label>
                                                    <select name="holder_gross_annual_income" value={newholderData.holder_gross_annual_income} onChange={handleSecondHolderata}>
                                                        <option value="">Select</option>
                                                        <option value="01">BELOW 1 LAC</option>
                                                        <option value="02">1-5 LAC</option>
                                                        <option value="03">5-10 LAC</option>
                                                        <option value="04">10-25 LAC</option>
                                                        <option value="05">25LAC-1CR</option>
                                                        <option value="06">Greater than 1 CR</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {incometype == 2 ? (
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="ecan-form-group">
                                                    <label>Networth (in Rs.)<span style={{ color: '#ff0000' }}>*</span></label>
                                                    <input name="holder_networth" value={newholderData.holder_networth} onChange={handleSecondHolderata} type="text"></input>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="ecan-form-group">
                                                    <label>As on date<span style={{ color: '#ff0000' }}>*</span></label>
                                                    <input name="holder_networth_ondate" value={newholderData.holder_networth_ondate} onChange={handleSecondHolderata} type="date"></input>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Source of Wealth<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select value={holder_source_of_wealth}
                                                    onChange={(e) => {
                                                        setholder_source_of_wealth(e.target.value)
                                                        if (e.target.value == "08") {
                                                            setothersourceofwealth(1);
                                                        } else {
                                                            setothersourceofwealth(0);
                                                        }
                                                    }}>
                                                    <option value="">Select</option>
                                                    <option value="01">Salary</option>
                                                    <option value="02">Bussiness Income</option>
                                                    <option value="03">Gift</option>
                                                    <option value="04">Ancestral Property</option>
                                                    <option value="05">Rental Income</option>
                                                    <option value="06">Prize Money</option>
                                                    <option value="07">Royalty</option>
                                                    <option value="08">Others</option>
                                                </select>
                                            </div>
                                        </div>
                                        {othersourceofwealth == 1 ? (
                                            <div className="col-lg-6">
                                                <div className="ecan-form-group">
                                                    <label>Other</label>
                                                    <input name="holder_source_of_wealth_other" value={newholderData.holder_source_of_wealth_other} onChange={handleSecondHolderata} type="text"></input>
                                                </div>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Occupation<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select value={holder_occupation}
                                                    onChange={(e) => {
                                                        setholder_occupation(e.target.value);
                                                        if (e.target.value == "99") {
                                                            setotheroccupation(1);
                                                        } else {
                                                            setotheroccupation(0);
                                                        }
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="01">Private Sector Service</option>
                                                    <option value="02">Public Sector</option>
                                                    <option value="03">Business</option>
                                                    <option value="04">Professional</option>
                                                    <option value="05">Agriculturist</option>
                                                    <option value="06">Retired</option>
                                                    <option value="07">Housewife</option>
                                                    <option value="08">Student</option>
                                                    <option value="09">Forex Dealer</option>
                                                    <option value="10">Government Service</option>
                                                    <option value="99">Others</option>
                                                </select>
                                            </div>
                                        </div>
                                        {otheroccupation == 1 ? (
                                            <div className="col-lg-6">
                                                <div className="ecan-form-group">
                                                    <label>Other</label>
                                                    <input name="holder_occupation_other" value={newholderData.holder_occupation_other} onChange={handleSecondHolderata} type="text"></input>
                                                </div>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Political Exposure<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="holder_political_exposure" value={newholderData.holder_political_exposure} onChange={handleSecondHolderata}>
                                                    <option value="">Select</option>
                                                    <option value="NA"   >Not Applicable</option>
                                                    <option value="PEP" >Politically Exposed Person</option>
                                                    <option value="RPEP">
                                                        Related to Politically Exposed Person
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Your Address Type<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="holder_kra_addr_type" value={newholderData.holder_kra_addr_type} onChange={handleSecondHolderata}>
                                                    <option value="">Select</option>
                                                    <option value="1">Residential or Business</option>
                                                    <option value="2">Residential</option>
                                                    <option value="3">Business</option>
                                                    <option value="4">Registered Office</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <h6>FATCA Details of Guardian</h6>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Tax Residency in a country other than India?<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="holder_tax_resedency_other_than_india" value={newholderData.holder_tax_resedency_other_than_india} onChange={handleSecondHolderata}>
                                                    <option value="N">
                                                        No - Not a Tax Resident in a Country other than India
                                                    </option>
                                                    {/* <option value="Y">
                            Yes - Tax Resident in a Country other than India
                        </option> */}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Place of Birth<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="holder_place_of_birth" value={newholderData.holder_place_of_birth} onChange={handleSecondHolderata} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Country of Birth<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="holder_country_of_birth" value={newholderData.holder_country_of_birth} onChange={handleSecondHolderata}>
                                                    <option value="">Select Country Of Birth</option>
                                                    {Countries.map((option, index) => (
                                                        <option key={index} value={option.country_can_id}>
                                                            {option.country_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* <input name="cr_country_of_birth" disabled value={step1Data.cr_country_of_birth} onChange={handleInput} type="text"></input> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Country of Citizenship<span style={{ color: '#ff0000' }}>*</span></label>

                                                <select name="holder_country_of_citizenship" value={newholderData.holder_country_of_citizenship} onChange={handleSecondHolderata}>
                                                    <option value="">Select Country Of Citizenship</option>
                                                    {Countries.map((option, index) => (
                                                        <option key={index} value={option.country_can_id}>
                                                            {option.country_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* <input name="cr_country_of_citizenship" disabled value={step1Data.cr_country_of_citizenship} onChange={handleInput}type="text"></input> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Country of Nationality<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="holder_country_of_nationality" value={newholderData.holder_country_of_nationality} onChange={handleSecondHolderata}>
                                                    <option value="">Select Country Of Nationality</option>
                                                    {Countries.map((option, index) => (
                                                        <option key={index} value={option.country_can_id}>
                                                            {option.country_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* <input name="cr_country_of_nationality" disabled value={step1Data.cr_country_of_nationality} onChange={handleInput} type="text"></input> */}
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        errorMessage != '' ?
                                            <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                                    }
                                    <div className="theme-button mg-t-10">
                                        <a className="btn" onClick={previousstep}>
                                            Back
                                        </a>
                                        <a className="btn mg-l-10" onClick={processsnewholder}>
                                            Save & Continue
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {step == 4 ? (
                            <div className="col-lg-9">
                                <div className="ecan-form">
                                    <h6>Default Bank Account details</h6>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Bank A/c No<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="crb_bank_acc_no1" style={{ WebkitTextSecurity: 'square' }} inputProps={{ inputMode: 'numeric' }} value={userbankdata.crb_bank_acc_no1} onChange={handleBankData} type="number"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Re-Enter Bank A/c No<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="confirm_bank_acc_no1" value={userbankdata.confirm_bank_acc_no1} onChange={handleBankData} type="number"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Account Type<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="crb_bank_acc_type1" value={userbankdata.crb_bank_acc_type1} onChange={handleBankData}>
                                                    <option value="">Select</option>
                                                    <option value="CA">Current Account</option>
                                                    <option value="CC">Cash Credit</option>
                                                    <option value="FCNR">Foreign Currency Non Resident</option>
                                                    <option value="NRE">Non Resident External Account</option>
                                                    <option value="NRO">Non Resident Ordinary A/c</option>
                                                    <option value="OD">Over Draft Account</option>
                                                    <option value="OTH">Others</option>
                                                    <option value="PSB">Post Office Savings Account</option>
                                                    <option value="SB">Savings Account</option>
                                                    <option value="SNRA">Special Non Resident Rupee A/c</option>
                                                    <option value="SNRR">Special Non Resident repatriable</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Bank<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="crb_bank1" value={userbankdata.crb_bank1} onChange={handleBankData}>
                                                    <option value="">Select Bank</option>
                                                    {Banks.map((option, index) => (
                                                        <option key={index} value={option.bank_can_id}>
                                                            {option.bank_name}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* <input name="crb_bank1" value={userbankdata.crb_bank1} onChange={handleBankData} type="text"></input> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>IFSC<span style={{ color: '#ff0000' }} >*</span></label>
                                                <input name="crb_bank_ifsc1" style={{ textTransform: 'uppercase' }} value={userbankdata.crb_bank_ifsc1} onChange={handleBankData} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>MICR<span style={{ color: '#ff0000' }}>*</span></label>
                                                <input name="crb_bank_micr1" defaultValue={micrName != '' ? micrName : userbankdata.crb_bank_micr1} onChange={handleBankData} type="text"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ecan-form-group">
                                                <label>Bank Proof<span style={{ color: '#ff0000' }}>*</span></label>
                                                <select name="crb_bank_proof1" value={userbankdata.crb_bank_proof1} onChange={handleBankData}>
                                                    <option value="">Select</option>
                                                    <option value="14">Latest Bank Passbook</option>
                                                    <option value="15">Latest Bank Account Statement</option>
                                                    <option value="77">Cancelled Cheque Copy</option>
                                                    <option value="78">Bank Letter</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" class="buttonab-line mg-b-20" style={{ marginLeft: '0px', paddingLeft: '0px', marginBottom: '20px' }} onClick={(e) => {
                                        if (showmorebanks == 1) { setshowmorebanks(0); }
                                        else { setshowmorebanks(1); }

                                    }}>{showmorebanks == 1 ? 'Remove' : 'Add another bank account'}<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                    {showmorebanks == 1 ?
                                        <>
                                            <hr></hr>
                                            <h6>Second Bank Account</h6>
                                            <hr></hr>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Bank A/c No</label>
                                                        <input name="crb_bank_acc_no2" value={userbankdata.crb_bank_acc_no2} onChange={handleBankData} type="number"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Re-Enter Bank A/c No</label>
                                                        <input name="confirm_bank_acc_no2" value={userbankdata.confirm_bank_acc_no2} onChange={handleBankData} type="number"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Account Type</label>
                                                        <select name="crb_bank_acc_type2" value={userbankdata.crb_bank_acc_type2} onChange={handleBankData}>
                                                            <option value="">Select</option>
                                                            <option value="CA">Current Account</option>
                                                            <option value="CC">Cash Credit</option>
                                                            <option value="FCNR">Foreign Currency Non Resident</option>
                                                            <option value="NRE">Non Resident External Account</option>
                                                            <option value="NRO">Non Resident Ordinary A/c</option>
                                                            <option value="OD">Over Draft Account</option>
                                                            <option value="OTH">Others</option>
                                                            <option value="PSB">Post Office Savings Account</option>
                                                            <option value="SB">Savings Account</option>
                                                            <option value="SNRA">Special Non Resident Rupee A/c</option>
                                                            <option value="SNRR">Special Non Resident repatriable</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Bank</label>
                                                        <select name="crb_bank2" value={userbankdata.crb_bank2} onChange={handleBankData}>
                                                            <option value="">Select Bank</option>
                                                            {Banks.map((option, index) => (
                                                                <option key={index} value={option.bank_can_id}>
                                                                    {option.bank_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {/* <input name="crb_bank2" value={userbankdata.crb_bank2} onChange={handleBankData} type="text"></input> */}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>MICR</label>
                                                        <input name="crb_bank_micr2" value={userbankdata.crb_bank_micr2} onChange={handleBankData} type="text"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>IFSC</label>
                                                        <input name="crb_bank_ifsc2" value={userbankdata.crb_bank_ifsc2} onChange={handleBankData} type="text"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Bank Proof</label>
                                                        <select name="crb_bank_proof2" value={userbankdata.crb_bank_proof2} onChange={handleBankData}>
                                                            <option value="">Select</option>
                                                            <option value="14">Latest Bank Passbook</option>
                                                            <option value="15">Latest Bank Account Statement</option>
                                                            <option value="77">Cheque Copy</option>
                                                            <option value="78">Bank Letter</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr></hr>
                                            <h6>Third Bank Account</h6>
                                            <hr></hr>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Bank A/c No</label>
                                                        <input name="crb_bank_acc_no3" value={userbankdata.crb_bank_acc_no3} onChange={handleBankData} type="number"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Re-Enter Bank A/c No</label>
                                                        <input name="confirm_bank_acc_no3" value={userbankdata.confirm_bank_acc_no3} onChange={handleBankData} type="number"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Account Type</label>
                                                        <select name="crb_bank_acc_type3" value={userbankdata.crb_bank_acc_type3} onChange={handleBankData}>
                                                            <option value="">Select</option>
                                                            <option value="CA">Current Account</option>
                                                            <option value="CC">Cash Credit</option>
                                                            <option value="FCNR">Foreign Currency Non Resident</option>
                                                            <option value="NRE">Non Resident External Account</option>
                                                            <option value="NRO">Non Resident Ordinary A/c</option>
                                                            <option value="OD">Over Draft Account</option>
                                                            <option value="OTH">Others</option>
                                                            <option value="PSB">Post Office Savings Account</option>
                                                            <option value="SB">Savings Account</option>
                                                            <option value="SNRA">Special Non Resident Rupee A/c</option>
                                                            <option value="SNRR">Special Non Resident repatriable</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Bank</label>
                                                        <select name="crb_bank3" value={userbankdata.crb_bank3} onChange={handleBankData}>
                                                            <option value="">Select Bank</option>
                                                            {Banks.map((option, index) => (
                                                                <option key={index} value={option.bank_can_id}>
                                                                    {option.bank_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {/* <input name="crb_bank3" value={userbankdata.crb_bank3} onChange={handleBankData} type="text"></input> */}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>MICR</label>
                                                        <input name="crb_bank_micr3" value={userbankdata.crb_bank_micr3} onChange={handleBankData} type="text"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>IFSC</label>
                                                        <input name="crb_bank_ifsc3" value={userbankdata.crb_bank_ifsc3} onChange={handleBankData} type="text"></input>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ecan-form-group">
                                                        <label>Bank Proof</label>
                                                        <select name="crb_bank_proof3" value={userbankdata.crb_bank_proof3} onChange={handleBankData}>
                                                            <option value="">Select</option>
                                                            <option value="14">Latest Bank Passbook</option>
                                                            <option value="15">Latest Bank Account Statement</option>
                                                            <option value="77">Cheque Copy</option>
                                                            <option value="78">Bank Letter</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </> : ''
                                    }
                                    {
                                        errorMessage != '' ?
                                            <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                                    }
                                    <div className="theme-button mg-t-10">
                                        <a className="btn" onClick={previousstep}>
                                            Back
                                        </a>
                                        <a className="btn mg-l-10" onClick={processstep3}>
                                            Save & Continue
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                       {step == 5 ? (
                            <div className="col-lg-9">
                                <div className="ecan-form">
                                    <h6>Nominee details</h6>
                                    <hr></hr>
                                    <div className="col-lg-12">
                                        <div className="ecan-form-group">
                                            <label>Nomination Option<span style={{ color: '#ff0000' }}>*</span></label>
                                            <select
                                                onChange={(e) => {
                                                    setcr_nominee_option(e.target.value);
                                                    if (e.target.value == "N") {
                                                        setaddnominee(0);
                                                    } else {
                                                        setaddnominee(1);
                                                    }
                                                }}>
                                                <option value="Y" >Yes - I wish to Nominate</option>
                                                <option value="N">No - I do not want to Nominate</option>
                                            </select>
                                        </div>
                                        {addnominee == 1 ? (
                                            <>
                                                <hr></hr>
                                                <h6>First Nominee</h6>
                                                <hr></hr>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Name of Nominee<span style={{ color: '#ff0000' }}>*</span></label>
                                                            <input name="crn_nominee_name1" value={nomineeData.crn_nominee_name1} onChange={handleNomineeData} type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Relationship<span style={{ color: '#ff0000' }}>*</span></label>
                                                            <input name="crn_nominee_relation1" value={nomineeData.crn_nominee_relation1} onChange={handleNomineeData} type="text" />

                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Percent(%)<span style={{ color: '#ff0000' }}>*</span></label>
                                                            <input name="crn_nominee_percent1" value={nomineeData.crn_nominee_percent1} onChange={handleNomineeData} type="number" />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="ecan-form-group">
                                                            <label>Date of Birth<span style={{ color: '#ff0000' }}>*</span></label>
                                                            <input name="crn_nominee_dob1" value={nomineeData.crn_nominee_dob1} onChange={handleNomineeData} type="date" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="submit" class="buttonab-line mg-b-20" style={{ marginLeft: '0px', paddingLeft: '0px', marginBottom: '20px' }} onClick={(e) => {
                                                    if (showmorenominee == 1) { setshowmorenominee(0); }
                                                    else { setshowmorenominee(1); }
                                                }}>{showmorenominee == 1 ? 'Remove' : 'Add another nominee'}<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                               {showmorenominee == 1 ?
                                                    <>
                                                        <h6>Second Nominee</h6>
                                                        <hr></hr>
                                                        <div className="row">
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Name of Nominee</label>
                                                                    <input name="crn_nominee_name2" value={nomineeData.crn_nominee_name2} onChange={handleNomineeData} type="text" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Relationship</label>
                                                                    <input name="crn_nominee_relation2" value={nomineeData.crn_nominee_relation2} onChange={handleNomineeData} type="text" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Percent(%)</label>
                                                                    <input name="crn_nominee_percent2" value={nomineeData.crn_nominee_percent2} onChange={handleNomineeData} type="number" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Date of Birth</label>
                                                                    <input name="crn_nominee_dob2" value={nomineeData.crn_nominee_dob2} onChange={handleNomineeData} type="date" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h6>Third Nominee</h6>
                                                        <hr></hr>
                                                        <div className="row">
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Name of Nominee</label>
                                                                    <input name="crn_nominee_name3" value={nomineeData.crn_nominee_name3} onChange={handleNomineeData} type="text" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Relationship</label>
                                                                    <input name="crn_nominee_relation3" value={nomineeData.crn_nominee_relation3} onChange={handleNomineeData} type="text" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Percent(%)</label>
                                                                    <input name="crn_nominee_percent3" value={nomineeData.crn_nominee_percent3} onChange={handleNomineeData} type="number" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="ecan-form-group">
                                                                    <label>Date of Birth</label>
                                                                    <input name="crn_nominee_dob3" value={nomineeData.crn_nominee_dob3} onChange={handleNomineeData} type="date" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </> : ''
                                                }
                                            </>
                                        ) : (
                                            ""
                                        )}
                                        <div className="theme-button mg-t-10">
                                            {nomineebackbutton == 1 ?
                                                <a className="btn mg-r-10" onClick={previousstep}>
                                                    Back
                                                </a> : ''}
                                            <a className="btn" onClick={processstep4}>
                                                Save & Continue
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {step == 6 ? (
                            <div className="col-lg-9">
                                <div className="ecan-form">
                                    <h6>Proof Upload</h6>
                                    <hr></hr>
                                    <div className="row">
                                        <p>Please ensure that you upload all the required document proofs before Submit eCAN as you will not be permitted to upload any document images once the CAN data is VERIFIED at MFU.</p>
                                        <div className="col-lg-12">
                                            <div className="ecan-form-group">
                                                <button type="button" className="btn btn-primary" onClick={(e) => onButtonClick(inputPANFile)}>
                                                    <i class="fa fa-plus" style={{ marginRight: '5px' }} aria-hidden="true"></i>
                                                    Upload Self Attested PAN Card Copy
                                                </button>
                                                <button type="button" className="btn btn-primary" style={{ marginLeft: '10px' }} onClick={(e) => onButtonClick(inputBANKFile)}>
                                                    <i class="fa fa-plus" style={{ marginRight: '5px' }} aria-hidden="true"></i>
                                                    Upload Bank Account Proof
                                                </button>
                                                {IsMinor == 1 ?
                                                    <button type="button" className="btn btn-primary" style={{ marginLeft: '10px' }} onClick={(e) => onButtonClick(inputMINORFile)}>
                                                        <i class="fa fa-plus" style={{ marginRight: '5px' }} aria-hidden="true"></i>
                                                        Upload Minor Account Proof
                                                    </button> : ''}
                                                <h6 style={{ marginTop: '25px' }}><a href="/img/bankstatementsamples.png" target="new">(Bank Statement Sample)</a><i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6>
                                                <h6 style={{ marginTop: '25px' }}><a href="/img/cancelledchequesample.png" target="new">(Cancel Cheque Sample)</a><i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6>
                                                <h6 style={{ marginTop: '25px' }}><a href="/img/AttestedPANSample.png" target="new">(PanCard Sample)</a><i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6>
                                                <h6 style={{ marginTop: '25px' }}>Only For Minor (Read Point 7 Below)<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6>

                                                <input
                                                    type="file"
                                                    id='file'
                                                    ref={inputPANFile}
                                                    style={{ display: 'none' }}
                                                    onChange={uploadPAN}
                                                />
                                                <input
                                                    type="file"
                                                    id='file'
                                                    ref={inputBANKFile}
                                                    style={{ display: 'none' }}
                                                    onChange={uploadBANK}
                                                />
                                                <input
                                                    type="file"
                                                    id='file'
                                                    ref={inputMINORFile}
                                                    style={{ display: 'none' }}
                                                    onChange={uploadSMINOR}
                                                />
                                            </div></div>
                                        <div className="col-lg-12">
                                            <div className="ecan-form-group">
                                                {PANproof != null && PANproof != '' ?
                                                    <table role="presentation" className="table table-striped">
                                                        <thead style={{ textAlign: "center" }}>
                                                            <tr>
                                                                <th width="15%">Image Preview</th>
                                                                <th width="38%">Proof Type</th>
                                                                <th className="text-right" colSpan="2" width="25%">Options</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="template-upload in" style={{ textAlign: "center" }}>
                                                                <td className="preview">
                                                                    <span className="in"><img src={URL.createObjectURL(PANproof)} alt="" height={'50px'} width={'50px'} /></span>
                                                                </td>
                                                                <td>PAN</td>

                                                                <td>
                                                                    <button type="button" className="btn btn-primary newsletter-button" onClick={() => removeimageserver(PANProofId)}>Remove Image</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    : ''
                                                }
                                                {BANKproof != null && BANKproof != '' ?
                                                    <table role="presentation" className="table table-striped">
                                                        <thead style={{ textAlign: "center" }}>
                                                            <tr>
                                                                <th width="15%">Image Preview</th>
                                                                <th width="38%">Proof Type</th>
                                                                <th className="text-right" colSpan="2" width="25%">Options</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="template-upload in" style={{ textAlign: "center" }}>
                                                                <td className="preview">
                                                                    <span className="in"><img src={URL.createObjectURL(BANKproof)} alt="" height={'50px'} width={'50px'} /></span>
                                                                </td>
                                                                <td>BANK PROOF</td>
                                                                <td>
                                                                    <button type="button btn-danger" className="btn btn-primary newsletter-button" onClick={() => removeimageserver(BANKProofId)}>Remove Image</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    : ''
                                                }
                                                {MINORproof != null && MINORproof != '' ?
                                                    <table role="presentation" className="table table-striped">
                                                        <thead style={{ textAlign: "center" }}>
                                                            <tr>
                                                                <th width="15%">Image Preview</th>
                                                                <th width="38%">Proof Type</th>
                                                                <th className="text-right" colSpan="2" width="25%">Options</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="template-upload in" style={{ textAlign: "center" }}>
                                                                <td className="preview">
                                                                    <span className="in"><img src={URL.createObjectURL(MINORproof)} alt="" height={'50px'} width={'50px'} /></span>
                                                                </td>
                                                                <td>MINOR PROOF</td>
                                                                <td>
                                                                    <button type="button btn-danger" className="btn btn-primary newsletter-button" onClick={() => removeimageserver(BANKProofId)}>Remove Image</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    : ''
                                                }
                                            </div>
                                        </div>
                                        {
                                            errorMessage != '' ?
                                                <div style={{ color: 'red' }}>{errorMessage}</div> : ''
                                        }
                                        <div className="theme-button mg-t-10">
                                            <a style={{ marginBottom: '10px' }} className="btn" onClick={checkbankproofvaklidation}>
                                                Submit For eCAN
                                            </a>
                                        </div>
                                        <small>
                                            Note: The allowed image file formats ( GIF, JPG | JPEG, PNG, BMP ). Recommended file size should not be more than 500 KB.
                                            <ol>
                                                <li>The PAN proof MUST be SELF ATTESTED by respective PAN holder</li>
                                                <li>Bank document proof for each of the bank added :</li>
                                                <li>Bank statement must be latest (of the last 3 months) with Bank A/C type, MICR, IFSC Code & Bank Account number (without masking) OR</li>
                                                <li>Cheque image should have CAN Primary holder/MINOR name printed on it along with above details OR</li>
                                                <li>Bank letter with all the above details</li>
                                                <li>For MINORs birth certificate should have</li>
                                                <li>MINOR Name & DOB along with Guardian Name printed on it OR</li>
                                                <li>Court Order for Appointed Guardian</li>
                                                <li>Sole-Proprietor proof should have</li>
                                                <li>GST Certificate / Banker letter / Gumasta license where Sole-Proprietor Firm Name and PAN is appearing    </li>
                                            </ol>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </div>;
                <SweetAlert warning confirmBtnCssClass='alertpop' onConfirm={completekyc} confirmBtnText='Click Here' title={canmodalText} show={show}>
               </SweetAlert>
                <SweetAlert success confirmBtnCssClass='alertpop' onConfirm={stepincrement} confirmBtnText='Continue' title={canmodalText} show={successshow}>
                </SweetAlert>
                <SweetAlert danger confirmBtnCssClass='alertpop' onConfirm={(e) => setdangerShow(false)} title={canmodalText} show={dangershow}>
                </SweetAlert>
            </section>
            <Footer />
        </div>
    );
}
export default CANRegister;